import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { COMMISSION_TYPE_LABELS } from '../../../../types/commission.types';
import { CommissionInvoiceLineItem } from '../../../../types/commission-invoice.types';

@Component({
  standalone: true,
  imports: [RouterLink],
  selector: 'lib-commission-invoice-line-items',
  templateUrl: './commission-invoice-line-items.component.html',
})
export class CommissionInvoiceLineItemsComponent {
  lineItems = input.required<CommissionInvoiceLineItem[]>();
  currency = input.required<string>();

  protected readonly lineItemTotal = computed(() =>
    this.lineItems().reduce((sum, item) => sum + item.amount_minor, 0)
  );

  protected typeLabel(type: string): string {
    return COMMISSION_TYPE_LABELS[type] ?? this.titleCase(type);
  }

  protected titleCase(value?: string): string {
    if (!value) return '-';
    return value
      .replace(/_/g, ' ')
      .replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1));
  }

  protected formatMoney(amountMinor?: number, currency = 'KES'): string {
    if (amountMinor === undefined || amountMinor === null) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amountMinor / 100);
  }
}
